// extracted by mini-css-extract-plugin
export var buttonIconWrapper = "_bx-4";
export var collapsed = "_bx-1";
export var headerBar = "_bx-0";
export var leftHeaderContent = "_bx-3";
export var subjectContainer = "_bx-2";